import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { BulkSettingErrorViewModel } from '../device-group-list-table/device-group-list-table.component';

export type DeviceGroupBulkSettingErrorDialogOption = {
  title?: string;
  message: string;
  data: BulkSettingErrorViewModel[];
};

@Component({
  selector: 'app-device-group-bulk-setting-error-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    MatTableModule,
  ],
  templateUrl: './device-group-bulk-setting-error-dialog.component.html',
  styleUrl: './device-group-bulk-setting-error-dialog.component.scss',
})
export class DeviceGroupBulkSettingErrorDialogComponent {
  public title = 'Error';

  public message = '';

  public dataSource = new MatTableDataSource<BulkSettingErrorViewModel>([]);

  public readonly displayedColumns = ['deviceId', 'errorMessage'];

  constructor(
    @Inject(MAT_DIALOG_DATA) data: DeviceGroupBulkSettingErrorDialogOption,
  ) {
    this.title = data.title || this.title;
    this.message = data.message;
    this.dataSource.data = data.data;
  }
}
